export const MenuIcon = ({
  width = 26,
  height = 26,
  className,
  title = "Menu",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <rect x="4" y="8" width="16" height="1" rx="0.5" fill="currentColor" />
      <rect x="4" y="15" width="16" height="1" rx="0.5" fill="currentColor" />
    </svg>
  );
};
